import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-kpi-counter-box"},[_c('div',[_vm._v(_vm._s(_vm.counterName))]),_c('div',[_vm._v(_vm._s(_vm.counterTarget))]),_c(VDivider),_c('div',[_vm._v(_vm._s(_vm.value))]),(_vm.dimensionId)?_c('div',[_vm._v("dimensionId: "+_vm._s(_vm.dimensionId))]):_vm._e(),_c(VBtn,{staticClass:"delete-btn",attrs:{"icon":"","small":"","color":"primary"},on:{"click":_vm.remove}},[_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }